export const toggleSidebarVisibility = () => (async (dispatch, getState) => {
  dispatch({
    type: 'TOGGLE_SIDEBAR_VISIBILITY',
  });
});

export const toggleSidebarUnfoldable = () => (async (dispatch, getState) => {
  dispatch({
    type: 'TOGGLE_SIDEBAR_UNFOLDABLE',
  });
});

export const setSidebarHidden = () => (async (dispatch, getState) => {
  dispatch({
    type: 'SET_SIDEBAR_HIDDEN',
  });
});

export const setTheme = (theme) => (async (dispatch, getState) => {
  dispatch({
    type: 'SET_APP_THEME',
    theme: theme,
  });
});